import React from 'react'
import OrganizationForms from '../../components/User/DynamicForms/OrganizationForms';
import Layout from './Layout'; 

export const FormsPage = () => <Layout><OrganizationForms /></Layout>